import { render } from "./EnhancedAnalytics.vue?vue&type=template&id=ba6b1bfc&scoped=true"
import script from "./EnhancedAnalytics.vue?vue&type=script&lang=js"
export * from "./EnhancedAnalytics.vue?vue&type=script&lang=js"

import "./EnhancedAnalytics.vue?vue&type=style&index=0&id=ba6b1bfc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6b1bfc"]])

export default __exports__